import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Modal } from '@flipster/react/design-system/modal';
import { css } from '@flipster/styled-system/css';
import segment from '@flipster/utils/segment';
import { ProfileEvent } from '@flipster/utils/segment/events/profile';

import { SegmentPage } from '../../../misc/segment/segment-page';

const MakePublicLabel = 'Make both public to add links';

interface PublicAgreementProps {
  onPrimary: () => void;
  onSecondary: () => void;
  secondaryLabel: string;
}
const PublicAgreement = ({ onPrimary, onSecondary, secondaryLabel }: PublicAgreementProps) => {
  const t = useTranslations();
  return (
    <>
      <SegmentPage name='switch_public_modal_view' />
      <Modal.Header>
        <Modal.Title label={t('Autogen_common.r251126.s_Set_both_to_public_to_add_social_links')} />
      </Modal.Header>
      <Modal.Content>
        <section className={css({ whiteSpace: 'pre-wrap' })}>
          <FormattedMessage id='Autogen_common.r251126.s_To_add_social_links_both_performance_and_trading_activity_must_be_set_to_public' />
          <br />
          <br />
          <FormattedMessage id='Autogen_common.r251126.s_Switching_to_public_makes_your_trading_history_and_performance_visible_as_well' />
          &nbsp;
          <FormattedMessage id='Autogen_common.r251126.s_You_can_always_go_back_to_private_anytime' />
        </section>
      </Modal.Content>
      <Modal.Footer align='vertical'>
        <Modal.Button
          hierarchy='secondary'
          size='large'
          color='neutral'
          label={secondaryLabel}
          withSpinner
          onClick={() => {
            segment.track(ProfileEvent.SwitchPublicButtonClick, {
              button_text: secondaryLabel,
            });
            return onSecondary();
          }}
        />
        <Modal.Button
          size='large'
          label={t('Autogen_common.r251126.s_Make_both_public_to_add_links')}
          withSpinner
          onClick={() => {
            segment.track(ProfileEvent.SwitchPublicButtonClick, {
              button_text: MakePublicLabel,
            });
            return onPrimary();
          }}
        />
      </Modal.Footer>
    </>
  );
};

export default PublicAgreement;
